import React from 'react'
import { Box } from '@cjdev-internal/visual-stack-x/components/Box';
import { Text } from '@cjdev-internal/visual-stack-x/components/Text';
import { Button } from '@cjdev-internal/visual-stack-x/Button'
import { PayeeInfoProps } from '../../../types'
import { Grid } from '@cjdev-internal/visual-stack-x/Grid'
import { HoverTooltip } from '@cjdev-internal/visual-stack-x/Tooltip'
import './index.css'

const PayeeInfo  = ({ name, lastModified, buttonLabel, onClick }: PayeeInfoProps) => {
  return (
    <div className="payee-info-container">
      <Grid gap={"2xl"} columns="1fr 1fr 1fr">
        <Box className="payee-info-box" paddingLeft={"2xl"} justify="center">
          <HoverTooltip content={name} >
            <Text className="payee-info-text" size="sm" weight="medium">
              {name}
            </Text>
          </HoverTooltip>
        </Box>
        <Grid gap={"xs"} columns="1fr 3fr 1fr" align="center">
          <Box/>
          <Box align={"center"}>
            <Text size="sm" color="secondary">
              {lastModified}
            </Text>
          </Box>
          <Box/>
        </Grid>
        <Grid gap={"xl"} columns="1fr 2fr 1fr" align="center">
          <Box/>
          <Box justify="center">
            <Button type="secondary" onClick={onClick}>
              {buttonLabel}
            </Button>
          </Box>
          <Box/>
        </Grid>
      </Grid>
    </div>
  );
};

export default PayeeInfo;
